"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Logo = _interopRequireDefault(require("../../Logo"));
var _CurrencyDropdown = _interopRequireDefault(require("../../../../CurrencyDropdown/CurrencyDropdown"));
var _ContactButton = _interopRequireDefault(require("../../../../ContactUs/ContactButton"));
var _constants = require("../../../../constants");
var BookingFunnel = function BookingFunnel(_ref) {
  var logo = _ref.logo,
    supportedCurrencies = _ref.supportedCurrencies,
    title = _ref.title,
    showContact = _ref.showContact,
    contactIconColor = _ref.contactIconColor,
    brand = _ref.brand,
    isPoweredBy = _ref.isPoweredBy;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "navbar--desktop booking-funnel max-width-lg margin-x-auto width-100% flex items-center justify-between"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "navbar--desktop__left width-100%"
  }, /*#__PURE__*/_react["default"].createElement(_Logo["default"], {
    config: logo,
    iconClassName: "icon--xl"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "navbar--desktop__center flex flex-center width-100%"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-text-bold d8-u-ls-sm"
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "navbar--desktop__right width-100% text-right flex"
  }, supportedCurrencies && /*#__PURE__*/_react["default"].createElement(_CurrencyDropdown["default"], {
    className: "height-100%",
    supportedCurrencies: supportedCurrencies,
    buttonType: _constants.BUTTON_TYPES.OUTLINE_PRIMARY,
    buttonSize: _constants.BUTTON_SIZES.SMALL
  }), showContact && /*#__PURE__*/_react["default"].createElement(_ContactButton["default"], {
    template: "OutlineContactButton",
    text: "Contact Us",
    brand: brand,
    color: contactIconColor,
    isPoweredBy: isPoweredBy,
    buttonType: _constants.BUTTON_TYPES.OUTLINE_PRIMARY
  })));
};
BookingFunnel.propTypes = {
  logo: _propTypes["default"].object,
  supportedCurrencies: _propTypes["default"].array,
  title: _propTypes["default"].string,
  homePath: _propTypes["default"].string.isRequired,
  showContact: _propTypes["default"].bool,
  brand: _propTypes["default"].string,
  contactIconColor: _propTypes["default"].string,
  isPoweredBy: _propTypes["default"].bool
};
var _default = exports["default"] = BookingFunnel;